import * as tslib_1 from "tslib";
import { OnInit, OnDestroy, NgZone, ElementRef } from '@angular/core';
import { SearchService } from '../services/search.service';
import { ChangeDetectorRef } from '@angular/core';
import { EnvService } from '../env.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, ModalController, LoadingController, Platform } from '@ionic/angular';
import { PromotionFiltersPage } from '../modals/promotion-filters/promotion-filters.page';
import { AutoCompletePlacePage } from '../modals/auto-complete-place/auto-complete-place.page';
import { GeoCodeService } from '../services/geo-code.service';
import * as _ from 'lodash';
import { TimezoneService } from '../services/timezone.service';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';
export class SearchPromotionsPage {
    constructor(searchService, cdRef, geoCodeService, envSevice, platform, route, router, ngZone, modalCtrl, alertCtrl, loadingCtrl, timezoneService, ga) {
        this.searchService = searchService;
        this.cdRef = cdRef;
        this.geoCodeService = geoCodeService;
        this.envSevice = envSevice;
        this.platform = platform;
        this.route = route;
        this.router = router;
        this.ngZone = ngZone;
        this.modalCtrl = modalCtrl;
        this.alertCtrl = alertCtrl;
        this.loadingCtrl = loadingCtrl;
        this.timezoneService = timezoneService;
        this.ga = ga;
        this.promotions = [];
        this.filteredPromotions = [];
        this.autocompleteItems = [];
        this.autocomplete = {
            input: ''
        };
        this.isDataHidden = false;
        this.isMap = false;
        this.filters = {
            duration: 'all',
            pricing: 'any',
            type: 'all',
            event_type: 'all' //class, bootcamp, workshop, teacher-training, all
        };
        this.markers = [];
        this.mapMarkers = [];
        this.clusterCache = [];
        this.initCall = false;
        this.addressSearchEnabled = false;
        this.noPromotionsFoundAlertPresent = false;
        this.activeAlert = null;
        this.loadMap = (lat = 49.2488091, lng = -122.9805104) => {
            const mapOptions = {
                center: { lat, lng },
                minZoom: 8,
                zoom: 8,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                disableDefaultUI: true,
                zoomControl: true,
                zoomControlOptions: {
                    style: google.maps.ZoomControlStyle.SMALL,
                    position: google.maps.ControlPosition.LEFT_TOP
                },
            };
            this.map = new google.maps.Map(this.gmap.nativeElement, mapOptions);
            //Added listener here to avoid losing listener during map reloading #PBL-565
            this.map.addListener("idle", () => {
                this.onMapBoundsChange();
            });
            this.forceScreenRefresh();
        };
        // this.promotions = [];
        this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
        this.autocomplete = {
            input: ''
        };
        this.autocompleteItems = [];
        this.address = {
            place: ''
        };
        this.userTimezone = timezoneService.getUserTimezone();
    }
    ionViewDidEnter() {
        amplitude.logEvent("mobile::visited_search_promotions_page");
    }
    ionViewWillEnter() {
        this.ga.startTrackerWithId('G-HTP42S7Y3P')
            .then(() => {
            console.log('Google Analytics tracker is ready');
            this.ga.trackView('Search Page');
        })
            .catch(e => console.log('Error starting Google Analytics', e));
        if (this.promotions && this.promotions.length > 0) {
            this.applyFilterGroup();
        }
    }
    presentAlert() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertCtrl.create({
                message: 'This activity holds an optional AfterSocial. Please go to the activity to find out more.',
                buttons: ['OK']
            });
            yield alert.present();
        });
    }
    presentAlertOnlineActivity() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertCtrl.create({
                message: 'Online activity',
                buttons: ['OK']
            });
            yield alert.present();
        });
    }
    presentAlertHybridActivity() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertCtrl.create({
                message: 'Choice of online or on-site activity.',
                buttons: ['OK']
            });
            yield alert.present();
        });
    }
    toggleMap() {
        this.isMap = !this.isMap;
        if (this.filteredPromotions.length == 0 && this.isMap) {
            this.showAlert();
        }
    }
    showPromotionDetails(promo) {
        this.router.navigate(['/promotion', promo.id]);
    }
    showStudio(promo) {
        this.router.navigate(['/venue', promo.classes.venue.username], { queryParams: { classId: promo.classes.id } });
    }
    showLoader() {
        this.loaderToShow = this.loadingCtrl.create({
            message: 'Loading...'
        }).then((res) => {
            res.present();
            res.onDidDismiss().then((dis) => {
                this.hideLoader();
            });
        });
    }
    hideLoader() {
        setTimeout(() => {
            this.loadingCtrl.dismiss();
        }, 1000);
    }
    presentModal() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const modal = yield this.modalCtrl.create({
                component: PromotionFiltersPage,
                componentProps: {
                    filters: this.filters
                }
            });
            modal.onDidDismiss()
                .then((modalData) => {
                this.filters = modalData.data ? modalData.data : this.filters;
                this.filteredPromotions = Object.assign(this.promotions, {});
                this.applyFilterGroup();
            });
            return yield modal.present();
        });
    }
    showAddressModal() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.addressSearchEnabled = true;
            const modal = yield this.modalCtrl.create({
                component: AutoCompletePlacePage
            });
            modal.onDidDismiss()
                .then((data) => {
                this.addressSearchEnabled = false;
                const selectedPlaceData = data;
                if (selectedPlaceData) {
                    this.selectedPlace = selectedPlaceData.data;
                    const geocoder = new google.maps.Geocoder();
                    geocoder.geocode({
                        address: this.selectedPlace
                    }, (results, status) => {
                        if (status === google.maps.GeocoderStatus.OK) {
                            this.showLoader();
                            let resLat = results[0].geometry.location.lat();
                            let resLng = results[0].geometry.location.lng();
                            this.geoCodeService.codeAddress(this.selectedPlace).subscribe(geodata => {
                                const geometry = geodata[0].geometry;
                                let newPlaceBounds;
                                const boundsSource = geometry.bounds || geometry.viewport;
                                if (boundsSource) {
                                    const boundaries = {
                                        NE: this.geoCodeService.googleLatLngToJson(boundsSource.getNorthEast()),
                                        SW: this.geoCodeService.googleLatLngToJson(boundsSource.getSouthWest())
                                    };
                                    newPlaceBounds = {
                                        sw: {
                                            lat: boundaries.SW.latitude,
                                            lng: boundaries.SW.longitude,
                                        },
                                        ne: {
                                            lat: boundaries.NE.latitude,
                                            lng: boundaries.NE.longitude,
                                        }
                                    };
                                }
                                else {
                                    newPlaceBounds = this.defaultBounds;
                                }
                                //Hardcoded it for  -#PBL-1029 - To rework
                                if (results[0]['formatted_address'] == 'Vancouver, BC, Canada') {
                                    newPlaceBounds = this.defaultBounds;
                                    resLat = 49.2488091,
                                        resLng = -122.9805104;
                                }
                                this.getPromotionData(newPlaceBounds, false);
                                this.loadMap(resLat, resLng);
                                this.renderMarkers();
                                const center = new google.maps.LatLng(resLat, resLng);
                                this.geoCodeService.geocode(center).forEach((gcresults) => {
                                })
                                    .then(() => console.log('Geocoding service: completed.'))
                                    .catch((error) => {
                                    if (error === google.maps.GeocoderStatus.ZERO_RESULTS) {
                                        console.log('zero results');
                                    }
                                });
                            });
                        }
                    });
                }
            });
            return yield modal.present();
        });
    }
    onTypeClick(ev, type) {
        if (this.filters.type === type) {
            this.filters.type = 'all';
            this.filters.event_type = 'all';
        }
        else {
            this.filters.type = type;
            this.filters.event_type = 'all';
        }
        this.filteredPromotions = Object.assign(this.promotions, {});
        this.applyFilterGroup();
    }
    onDurationClick(ev, duration) {
        if (this.filters.duration === duration) {
            this.filters.duration = 'all';
        }
        else {
            this.filters.duration = duration;
        }
        this.filteredPromotions = Object.assign(this.promotions, {});
        this.applyFilterGroup();
    }
    getSelectedTab() {
        console.log('tab event fired');
    }
    applyFilterGroup(initCall) {
        let purchasablePromotions = this.filteredPromotions;
        if (this.filters.duration === 'dropin') {
            purchasablePromotions = purchasablePromotions.filter((item) => this.searchService.filterIsDropIn(item));
            amplitude.logEvent("mobile::filtered_promotions_by_dropin");
        }
        else if (this.filters.duration === 'series') {
            purchasablePromotions = purchasablePromotions.filter((item) => this.searchService.filterIsSeries(item));
            amplitude.logEvent("mobile::filtered_promotions_by_series");
        }
        if (this.filters.pricing === 'discount') {
            purchasablePromotions = purchasablePromotions.filter((item) => this.searchService.filterIsDiscount(item));
            amplitude.logEvent("mobile::filtered_promotions_by_discount");
        }
        else if (this.filters.pricing === 'donation') {
            purchasablePromotions = purchasablePromotions.filter((item) => this.searchService.filterIsFree(item));
            amplitude.logEvent("mobile::filtered_promotions_by_donation");
        }
        else if (this.filters.pricing === 'any') {
            purchasablePromotions = purchasablePromotions.filter((item) => this.searchService.filterIsAny(item));
            amplitude.logEvent("mobile::filtered_promotions_by_any_pricing");
        }
        if (this.filters.type === 'yoga') {
            purchasablePromotions = purchasablePromotions.filter((item) => this.searchService.filterIsYoga(item));
            amplitude.logEvent("mobile::filtered_promotions_by_yoga");
        }
        else if (this.filters.type === 'dance') {
            purchasablePromotions = purchasablePromotions.filter((item) => this.searchService.filterIsDance(item));
            amplitude.logEvent("mobile::filtered_promotions_by_dance");
        }
        else if (this.filters.type === 'group-fitness') {
            purchasablePromotions = purchasablePromotions.filter((item) => this.searchService.filterIsGroupFitness(item));
            amplitude.logEvent("mobile::filtered_promotions_by_group_dance");
        }
        if (this.filters.event_type === 'class') {
            purchasablePromotions = purchasablePromotions.filter((item) => this.searchService.filterIsClass(item));
            amplitude.logEvent("mobile::filtered_promotions_by_class");
        }
        else if (this.filters.event_type === 'bootcamp') {
            purchasablePromotions = purchasablePromotions.filter((item) => this.searchService.filterIsBootcamp(item));
            amplitude.logEvent("mobile::filtered_promotions_by_bootcamp");
        }
        else if (this.filters.event_type === 'workshop') {
            purchasablePromotions = purchasablePromotions.filter((item) => this.searchService.filterIsWorkshop(item));
            amplitude.logEvent("mobile::filtered_promotions_by_workshop");
        }
        else if (this.filters.event_type === 'teacher-training') {
            purchasablePromotions = purchasablePromotions.filter((item) => this.searchService.filterIsTeacherTraining(item));
            amplitude.logEvent("mobile::filtered_promotions_by_teacher_training");
        }
        this.filteredPromotions = Object.assign(purchasablePromotions, {});
        if (!initCall) {
            setTimeout(() => {
                // this.getMarkers();
                this.drawMarkers(purchasablePromotions);
            }, 1000);
        }
    }
    ionChange(myTabs) {
        console.log(myTabs.getSelected());
    }
    getClass(item) {
        if (item.class) {
            return item.class;
        }
        else {
            return item.classes;
        }
    }
    updateSearchResults() {
        if (this.autocomplete.input === '') {
            this.autocompleteItems = [];
            return;
        }
        this.GoogleAutocomplete.getPlacePredictions({
            input: this.autocomplete.input
        }, (predictions, status) => {
            this.autocompleteItems = [];
            predictions.forEach((prediction) => {
                this.autocompleteItems.push(prediction);
            });
        });
    }
    // added function to refresh the screen
    forceScreenRefresh() {
        this.ngZone.run(() => {
            // console.log('force screen update!');
        });
    }
    renderMarkers() {
        this.markers.forEach(marker => {
            this.addMarker(marker);
        });
    }
    addMarker(marker) {
        const promoMarker = new google.maps.Marker({
            position: marker.position,
            map: this.map,
            title: marker.title,
            icon: marker.icon,
            url: marker.url,
        });
        google.maps.event.addListener(promoMarker, 'click', () => {
            window.location.href = promoMarker.url;
        });
        return promoMarker;
    }
    getMarkers() {
        let promotion;
        for (promotion of this.promotions) {
            this.addMarkersToMap(promotion);
        }
        this.renderMarkers();
    }
    addMarkersToMap(promo) {
        const marker = {
            position: {
                lat: parseFloat(promo.classes.venue.lat),
                lng: parseFloat(promo.classes.venue.lng),
            },
            title: promo.classes.title,
            icon: 'assets/images/map-icon-light.png',
            url: `${window.location.origin}#/promotion/${promo.id}`
        };
        this.markers.push(marker);
    }
    getClusterKey(promo) {
        const latKey = Math.floor(promo.classes.venue.lat / .0001) * .0001;
        const lngKey = Math.floor(promo.classes.venue.lng / .0001) * .0001;
        return latKey + ',' + lngKey;
    }
    floatEqual(a, b) {
        return Math.abs(a - b) < 0.000001;
    }
    drawMarkers(promotions) {
        // this.showLoader();
        const clusters = _(promotions)
            .groupBy(this.getClusterKey)
            .map((cluster, key) => {
            return {
                lat: parseFloat(cluster[0].classes.venue.lat),
                lng: parseFloat(cluster[0].classes.venue.lng),
                label: cluster.length + '',
                items: cluster
            };
        })
            .value();
        // split clusterCache into markers we keep (result[0]) and markers we get rid of (result[1])
        const result = _.partition(this.clusterCache, (mc) => {
            return _.some(clusters, (m) => {
                return this.floatEqual(mc.getPosition().lat(), m.lat) && this.floatEqual(mc.getPosition().lng(), m.lng);
            });
        });
        // pull out new markers to add from results
        // const newClusters = _.reject(clusters, (m) => {
        //     return _.some(result[0], (mc) => {
        //         return this.floatEqual(mc.getPosition().lat(), m.lat) && this.floatEqual(mc.getPosition().lng(), m.lng);
        //     });
        // });
        const newClusters = clusters;
        this.clusterCache.forEach((cluster) => {
            cluster.setMap(null);
        });
        this.clusterCache = _(newClusters)
            .map((c) => {
            const m = new google.maps.Marker({
                position: new google.maps.LatLng(c.lat, c.lng),
                map: this.map,
                title: c.items[0].title,
                icon: 'assets/images/map-icon-light.png',
                label: {
                    text: c.label,
                    color: 'white',
                    fontFamily: 'Open Sans',
                    fontSize: '18px'
                }
            });
            this.mapMarkers.push(m);
            m.addListener('click', () => {
                // map.panTo(m.getPosition());
                this.markerClicked(m);
                this.clusterClicked(c);
            });
            return m;
        })
            .union(result[0])
            .value();
        // this.hideLoader();
    }
    markerClicked(m) {
        // console.log('marker clicked');
    }
    clusterClicked(c) {
        if (c.items.length === 1) {
            this.router.navigate(['/promotion', c.items[0].id]);
        }
        else if (c.items.length > 1) {
            this.promotions = c.items;
            this.filteredPromotions = Object.assign(this.promotions, {});
            this.toggleMap();
        }
    }
    getPromotionData(defaultBounds, mapDragEvent, initCall) {
        this.searchService.getPromotions(defaultBounds).subscribe(data => {
            const rawResults = data;
            const allPromotions = Object.assign({}, rawResults);
            if (!this.isMap && (!allPromotions['result'] || allPromotions['result'].length == 0)) {
                this.filteredPromotions = [];
                this.cdRef.detectChanges();
                this.hideLoader();
                return;
            }
            // const purchasblePromotions = this.searchService.getPurchasablePromotions(allPromotions);
            this.promotions = allPromotions['result'];
            // if(!mapDragEvent){
            //     this.showAlert();
            // }
            this.promotions.forEach((promotion) => {
                if (promotion.classes.instructor) {
                    if ((promotion.classes.instructor.is_invited == 1 && promotion.classes.instructor.invitation_status !== 'ACCEPTED') ||
                        (promotion.classes.instructor.is_invited == 1 && promotion.classes.instructor.invitation_status == 'ACCEPTED' && !promotion.classes.instructor.is_profile_completed)) {
                        promotion.classes.instructor = promotion.user;
                    }
                }
            });
            this.filteredPromotions = Object.assign(this.promotions, {});
            this.applyFilterGroup(initCall);
            this.route.queryParams.subscribe((params) => {
                if (params && (Object.keys(params).length > 0)) {
                    if (params.venue_id) {
                        this.filteredPromotions = this.filteredPromotions.filter((item) => {
                            return item.classes.venue_id == params.venue_id;
                        });
                    }
                    else if (params.class_id) {
                        this.filteredPromotions = this.filteredPromotions.filter((item) => {
                            return item.class_id == params.class_id;
                        });
                    }
                    else if (params.promoter) {
                        this.filteredPromotions = this.filteredPromotions.filter((item) => {
                            return (item.user_id == params.promoter && ((item.classes.instructor.is_invited == 1 && item.classes.instructor.invitation_status != 'ACCEPTED') ||
                                (item.classes.instructor.is_invited == 1 && item.classes.instructor.invitation_status == 'ACCEPTED' && !item.classes.instructor.is_profile_completed)))
                                || (item.classes.instructor.id == params.promoter && (item.classes.instructor.is_invited != 1 || (item.classes.instructor.invitation_status == 'ACCEPTED' && item.classes.instructor.is_profile_completed)));
                        });
                    }
                    else {
                        this.filteredPromotions = this.promotions;
                        if (this.filteredPromotions.length == 0 && this.isMap) {
                            this.showAlert();
                        }
                    }
                }
                else {
                    this.filteredPromotions = this.promotions;
                    if (this.filteredPromotions.length == 0 && this.isMap) {
                        this.showAlert();
                    }
                }
            });
            this.hideLoader();
        });
    }
    ngOnInit() {
        this.route.queryParams.subscribe((params) => {
            this.showLoader();
            if (params.sw_lat && params.sw_lng && params.ne_lat && params.ne_lng) {
                this.defaultBounds = {
                    sw: {
                        lat: params.sw_lat,
                        lng: params.sw_lng
                    },
                    ne: {
                        lat: params.ne_lat,
                        lng: params.ne_lng
                    }
                };
                this.loadMap(Number(params.resLat), Number(params.resLng));
                this.getPromotionData(this.defaultBounds, false);
            }
            else {
                this.searchService.getGeoLocation().subscribe(res => {
                    if (res && res['result'] && res['result']['city']) {
                        const city = res['result']['city'].toLowerCase();
                        switch (city) {
                            case 'vancouver':
                                this.defaultBounds = {
                                    sw: {
                                        lat: 48.732117759871834,
                                        lng: -123.3491237265625
                                    },
                                    ne: {
                                        lat: 49.6057435563008,
                                        lng: -122.61029316015625
                                    }
                                };
                                this.loadMap(49.2488091, -122.9805104);
                                this.getPromotionData(this.defaultBounds, false);
                                break;
                            case 'toronto':
                                this.defaultBounds = {
                                    sw: {
                                        lat: 43.5810245,
                                        lng: -79.639219
                                    },
                                    ne: {
                                        lat: 43.8554579,
                                        lng: -79.1168971
                                    }
                                };
                                this.loadMap(43.625, -79.375);
                                this.getPromotionData(this.defaultBounds, false);
                                break;
                            default:
                                this.loadMap(res['result']['latitude'], res['result']['longitude']);
                                this.hideLoader();
                                break;
                        }
                    }
                    else {
                        this.loadMap(); //Load default vancouver map
                        this.hideLoader();
                    }
                });
            }
        });
        this.initCall = true;
    }
    changeCity(city) {
        switch (city) {
            case 'vancouver':
                this.defaultBounds = {
                    sw: {
                        lat: 48.732117759871834,
                        lng: -123.3491237265625
                    },
                    ne: {
                        lat: 49.6057435563008,
                        lng: -122.61029316015625
                    }
                };
                this.showLoader();
                this.loadMap(49.2488091, -122.9805104);
                this.getPromotionData(this.defaultBounds, false);
                break;
            case 'toronto':
                this.defaultBounds = {
                    sw: {
                        lat: 43.5810245,
                        lng: -79.639219
                    },
                    ne: {
                        lat: 43.8554579,
                        lng: -79.1168971
                    }
                };
                this.showLoader();
                this.loadMap(43.625, -79.375);
                this.getPromotionData(this.defaultBounds, false);
                break;
        }
    }
    ngOnDestroy() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const modal = yield this.modalCtrl.getTop();
            if (modal) {
                modal.dismiss();
            }
        });
    }
    onMapBoundsChange() {
        if (!this.isMap || this.addressSearchEnabled) {
            return;
        }
        let bounds = this.map.getBounds();
        const mapBounds = {
            sw: {
                lat: bounds.getSouthWest().lat(),
                lng: bounds.getSouthWest().lng()
            },
            ne: {
                lat: bounds.getNorthEast().lat(),
                lng: bounds.getNorthEast().lng()
            }
        };
        if (!this.initCall) {
            this.showLoader();
        }
        this.getPromotionData(mapBounds, true, this.initCall);
        this.initCall = false;
    }
    loadPromo(promo) {
        //   console.log(promo);
    }
    reset() {
        this.filters = {
            zoom: null,
            sessionTypes: [],
            pricingTypes: [],
            activityTypes: [],
            classTypes: [],
            city: null
        };
    }
    displayFilters() {
        return this.showFilters;
    }
    toggleFilters() {
        this.showFilters = !this.showFilters;
    }
    showInstructor(usr) {
        this.router.navigate(['/' + usr.username]);
    }
    showAlert() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.noPromotionsFoundAlertPresent) {
                return;
            }
            if ((this.promotions.length === 0) && this.isMap) {
                this.activeAlert = yield this.alertCtrl.create({
                    message: `
        <strong>SORRY, THERE ARE NO ACTIVITIES MATCHING YOUR CRITERIA.</strong><br>
        Change your search filters, move the map area, or change the city to 
        <a id="vancouver-link" style="color: #37C1DE; font-weight: bold; text-decoration: underline; cursor: pointer;">Vancouver, BC</a> or 
        <a id="toronto-link" style="color: #37C1DE; font-weight: bold; text-decoration: underline; cursor: pointer;">Toronto, ON</a>.
      `,
                    cssClass: 'text-center',
                    buttons: ['OK']
                });
                this.noPromotionsFoundAlertPresent = true;
                yield this.activeAlert.present();
                this.activeAlert.onDidDismiss().then(() => {
                    this.noPromotionsFoundAlertPresent = false;
                });
                // Wait a moment for DOM to render
                setTimeout(() => {
                    const vancouver = document.getElementById('vancouver-link');
                    const toronto = document.getElementById('toronto-link');
                    vancouver.addEventListener('click', () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                        this.changeCity('vancouver');
                        yield this.activeAlert.dismiss();
                    }));
                    toronto.addEventListener('click', () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                        this.changeCity('toronto');
                        yield this.activeAlert.dismiss();
                    }));
                }, 100); // Small delay to ensure DOM is rendered
            }
        });
    }
    ionViewDidLeave() {
        if (this.activeAlert) {
            this.activeAlert.dismiss();
            this.activeAlert = null;
        }
    }
    openTooltip(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            event.stopPropagation();
            const alert = yield this.alertCtrl.create({
                message: 'Online events are displayed in your local timezone.',
                buttons: ['OK']
            });
            yield alert.present();
        });
    }
}
